import { request } from '@@/plugin-request';

export async function getTodos(params) {
  return request('/api/onboarding/todos', {
    method: 'get',
    params,
  });
}
